import { render, staticRenderFns } from "./AddHailingLicenceInfo.vue?vue&type=template&id=db50e7d4&scoped=true"
import script from "./AddHailingLicenceInfo.vue?vue&type=script&lang=js"
export * from "./AddHailingLicenceInfo.vue?vue&type=script&lang=js"
import style0 from "./AddHailingLicenceInfo.vue?vue&type=style&index=0&id=db50e7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db50e7d4",
  null
  
)

export default component.exports